// extracted by mini-css-extract-plugin
export default {"container":"mainSlider-module__container--r32PT","single":"mainSlider-module__single--A3rod"};